<!-- Interactions modal — rendered at the builder's template ROOT (not inside a
     tile) so it's a real centered overlay, never clipped/cramped by the small
     tile card. Wires which live tiles an INPUT control drives, using its own
     draft state, so the left builder form/sidebar is untouched. -->
<div class="dvm-interactions-overlay" (click)="onCancel()">
  <div class="dvm-interactions-modal" (click)="$event.stopPropagation()">
    <div class="dvm-interactions-modal-head">
      <span>Interactions — {{ tile.title || (tile.layoutType | titlecase) }}</span>
      <button type="button" mat-icon-button (click)="onCancel()" aria-label="Close"><mat-icon>close</mat-icon></button>
    </div>
    <div class="dvm-interactions-modal-body">
      <div class="control-group control-group-full">
        <label>{{ isInput ? 'Target chart(s) / input(s) this control drives' : 'Target chart(s) / input(s) this chart interacts with' }}</label>
        <ng-select
          class="ss-select ss-select--multi ss-select--full"
          appendTo="body"
          ngClass="ss-dropdown-panel"
          [items]="targetOptions"
          bindLabel="label"
          bindValue="value"
          [multiple]="true"
          [closeOnSelect]="false"
          [hideSelected]="false"
          [clearable]="true"
          [searchable]="true"
          placeholder="Select the chart(s)/input(s) this control drives"
          [(ngModel)]="targets"
        ></ng-select>
        <small class="control-hint" *ngIf="!targetOptions.length">Add more charts/inputs to the dashboard first — they'll appear here.</small>
      </div>

      <!-- Per-target formulas/references only apply to INPUT controls (they
           push a computed value into each target). A chart tile just declares
           WHICH components it interacts with — the select above is enough. -->
      <div class="control-group control-group-full" *ngFor="let id of (isInput ? targets : [])">
        <ng-container *ngIf="host.isWaterfallTarget(id)">
          <span class="target-formula-name">{{ host.targetLabelForId(id) }} — per bar</span>
          <div class="target-formula-bar" *ngFor="let step of host.targetSteps(id); trackBy: host.trackByStepLabel">
            <div class="target-formula-row">
              <span class="target-formula-name">{{ step.label || step.stepType }}</span>
              <input type="text" [ngModel]="stepFormula(id, step.label)" (ngModelChange)="setStepFormula(id, step.label, $event)" placeholder="e.g. [price] * value" />
            </div>
            <ng-container *ngIf="host.formulaReferencesEnabledFor(host.targetLayoutTypeForId(id))">
              <ng-container *ngTemplateOutlet="refList; context: { id: id, step: step.label }"></ng-container>
            </ng-container>
          </div>
        </ng-container>
        <div *ngIf="!host.isWaterfallTarget(id)">
          <div class="target-formula-row">
            <span class="target-formula-name">{{ host.targetLabelForId(id) }}</span>
            <input type="text" [ngModel]="formulas[id] || ''" (ngModelChange)="formulas[id] = $event" [placeholder]="host.isInputControlTargetId(id) ? 'value (default — passes this control’s value through)' : 'e.g. [price] * value'" />
          </div>
          <!-- A CHART target with no formula is silently skipped by the
               recompute (nothing to calculate) — surface that instead. -->
          <div class="target-formula-row" *ngIf="!host.isInputControlTargetId(id) && !(formulas[id] || '').trim()">
            <small class="control-warning">No formula yet — "{{ host.targetLabelForId(id) }}" will NOT update when this control changes. Add one, e.g. [{{ host.targetLabelForId(id) }}]*(1+(value/100))</small>
          </div>
          <ng-container *ngIf="host.formulaReferencesEnabledFor(host.targetLayoutTypeForId(id))">
            <ng-container *ngTemplateOutlet="refList; context: { id: id }"></ng-container>
          </ng-container>
        </div>
      </div>

    </div>
    <div class="dvm-interactions-modal-foot">
      <button type="button" class="add-step-button" mat-stroked-button (click)="onCancel()">Cancel</button>
      <button type="button" class="add-step-button is-primary" mat-flat-button color="primary" (click)="onSave()">Save</button>
    </div>
  </div>
</div>

<!-- Reference rows — the modal's own state, separate from the create form's
     #referenceList so the two never clobber each other. -->
<ng-template #refList let-id="id" let-step="step">
  <div class="target-reference-list">
    <div class="target-reference-card" *ngFor="let ref of refs(id, step)">
      <div class="target-reference-card-header">
        <span>Reference</span>
        <button type="button" class="target-reference-remove" (click)="removeRef(id, ref)" title="Remove reference">&times;</button>
      </div>
      <div class="target-reference-grid">
        <div class="control-group"><label>Token</label><input type="text" [(ngModel)]="ref.token" placeholder="e.g. DN Price" /></div>
        <div class="control-group"><label>Input title</label><input type="text" [(ngModel)]="ref.inputTitle" placeholder="e.g. Price Inflation %" /></div>
        <div class="control-group"><label>Target label</label><input type="text" [(ngModel)]="ref.targetLabel" placeholder="e.g. Product Margins" /></div>
        <div class="control-group"><label>Row label</label><input type="text" [(ngModel)]="ref.rowLabel" placeholder="e.g. DN Price" /></div>
      </div>
    </div>
    <button type="button" class="target-reference-add" (click)="addRef(id, step)">+ Add reference</button>
  </div>
</ng-template>
